import { Button } from 'gf-ui-components-mui-lib';
import { CreatePlus } from '@/icons';
interface Props {
  onClick?: any;
  isSmallScreen?: any;
  children?: any;
  expandWidth?: any;
}

const AnimationButton = ({ onClick, isSmallScreen, children, expandWidth }: Props) => {
  return (
    <Button
      transitionbtn={true}
      variant="contained"
      onClick={onClick}
      expandTextStyles={{
        fontSize: isSmallScreen ? '14px' : '16px'
      }}
      expandWidth={expandWidth}
      sx={{
        display: 'inline-flex',
        height: '56px',
        width: '88px',
        padding: '12px 32px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '4px',
        background: 'var(--btn-01-primary-enabled, #2469F3)',
        minWidth: '0px',
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none'
        }
      }}
      children={children}
      Icon={<CreatePlus />}
    />
  );
};

export default AnimationButton;
